import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useAuth } from '../api/auth/store';
import { Container, Spinner, Alert } from 'react-bootstrap';

const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const { authorize } = useAuth();
    const [error, setError] = React.useState<string | null>(null);
    const [searchParams,_] = useSearchParams();

    useEffect(() => {
        const handleCallback = async () => {
            // Get code and company from URL parameters
            const code = searchParams.get('code');
            const company = searchParams.get('com');

            if (!code || !company) {
                setError('Invalid authentication response. Missing required parameters.');
                return;
            }

            try {
                // Exchange code for session
                await authorize(code, company);
                
                // Redirect to home page on success
                navigate('/');
            } catch (err) {
                console.error('Authentication failed:', err);
                setError('Authentication failed. Please try again.');
            }
        };

        handleCallback();
    }, [authorize, navigate]);

    if (error) {
        return (
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                <Alert variant="danger">
                    <Alert.Heading>Authentication Error</Alert.Heading>
                    <p>{error}</p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <button 
                            className="btn btn-outline-danger"
                            onClick={() => navigate('/login')}
                        >
                            Back to Login
                        </button>
                    </div>
                </Alert>
            </Container>
        );
    }

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <div className="text-center">
                <Spinner animation="border" role="status" className="mb-3">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <h4>Authenticating...</h4>
                <p className="text-muted">Please wait while we complete your login.</p>
            </div>
        </Container>
    );
};

export default AuthCallback;